<template>
  <div class="skill" v-if="model">
    <div class="name">{{ model.data.name }}</div>
    <div class="rating">
      <div class="range"
           ref="rangeNode"
           :style="{ width : `${rangePerc}%` }"
           :title="tooltip"></div>
    </div>
  </div>
</template>

<script>

export default {
    name       : "Skill",
    components : {},
    props      : {
        model : {
            type : Object
        }
    },
    data() {
        return {
            visible : false,
            ivlVis  : null
        };
    },
    computed : {
        rangePerc() {
            if (this.visible && this.model) {
                return parseFloat((this.model.rating() * 100).toFixed(2));
            }
            return 0;
        },
        tooltip() {
            return `${this.model.rating() * 10} / 10`;
        }
    },
    mounted() {
        this.startVisibilityCheck();
    },
    methods : {
        stopVisibilityCheck() {
            if (this.ivlVis) {
                clearInterval(this.ivlVis);
                this.ivlVis = null;
            }
        },
        startVisibilityCheck() {
            this.stopVisibilityCheck();

            if (this.visible) {
                return;
            }

            this.ivlVis = setInterval(() => { this.checkVisibility(); }, 100);
        },
        checkVisibility() {
            let notVisible = true;

            if (this.$refs.rangeNode) {
                const box = this.$refs.rangeNode.getBoundingClientRect();

                const winDims = {
                    w : window.innerWidth ||
                        document.documentElement.clientWidth,
                    h : window.innerHeight ||
                        document.documentElement.clientHeight - 100
                };

                notVisible = (
                    box.left < 0 ||
                    box.top < 0 ||
                    box.bottom > (winDims.h - 100) ||
                    box.right > winDims.w
                );
            }

            if (notVisible) {
                return;
            }

            this.stopVisibilityCheck();
            this.visible = true;
        }
    }
};

</script>

<style scoped>

.skill {
    width:300px;
    padding:10px 0px;
}

.name {
    font-size:16px;
    text-align:right;
    margin-bottom:0.5em;
}

.rating {
    outline:1px solid var(--resume-gray);
    height:4px;
    position:relative;
}

.range {
    position:absolute;
    top:0px;
    left:0px;
    width:0px;
    height:100%;
    background-image:-webkit-linear-gradient(to right, rgba(var(--main-orange-rgb), 0.1), rgba(var(--main-orange-rgb), 1));
    background-image:-moz-linear-gradient(to right, rgba(var(--main-orange-rgb), 0.1), rgba(var(--main-orange-rgb), 1));
    background-image:-ms-linear-gradient(to right, rgba(var(--main-orange-rgb), 0.1), rgba(var(--main-orange-rgb), 1));
    background-image:linear-gradient(to right, rgba(var(--main-orange-rgb), 0.1), rgba(var(--main-orange-rgb), 1));
    transition:width 2500ms;
}

.range:after {
    content:"";
    position:absolute;
    right:-5px;
    top:calc(50% - 4px);
    width:8px;
    height:8px;
    border-radius:50%;
    background-color:var(--core-white);
    box-shadow:0px 0px 6px 4px var(--main-orange);
}

</style>
